import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getTranslate} from 'react-localize-redux';
import api from '../../../helpers/api';
import {loadLanguage} from '../../../common/redux/localeReducer';
import {notifyError, notifySuccess} from '../../../common/redux/notificationReducer';
import {ContentLoader} from '../../../common/components/loader';
import dashboard5 from '../locales/dashboard5.json';
import {Label} from '../../../common/components/form';
import VSelect from "../../../common/components/form/VSelect";

import "video-react/dist/video-react.css";
import {Player, BigPlayButton, ControlBar, ReplayControl} from 'video-react';

import "react-bootstrap-modal/lib/css/rbm-patch.css";
import Modal from 'react-bootstrap-modal';
import {IconLink} from '../../../common/components/link';
import Lightbox from 'react-images';

class DashboardBox5 extends Component {
	constructor(props) {
		super(props);
		this.state = {
			modalOpen: false,
			modalVideoSrc: '',
			isLoading: true,
			allWorkOrders: [],
			businessUnitsList: [],
			workOrdersList: [],
			userApprovedStatusesList:[],
			statusesList:[],
			jobStatusesList:[],
			workInstructions: [],
			searchForm: {
				business_unit_id: '',
				work_order_id: '',
				status: 'Active',
				user_approved_status: 'Approved',
				job_status: 'Open'
			},
			isLightBoxOpen: false,
			lightBoxImages: [],
			lightBoxImageIndex: 0,
			intervalId: ''
		}
	}

	openModal = (e, src) => {
		if(src) {
			this.setState({ modalOpen: true, modalVideoSrc: src })
		}
	};
	closeModal = () => this.setState({ modalOpen: false });

	componentDidMount() {
		const {loadLanguage} = this.props;
		loadLanguage(dashboard5);
		this.loadDashboard();
	}

	updateSearchFormState = (object) => {
		const searchForm = {
			...this.state.searchForm,
			...object
		};
		this.setState({searchForm: searchForm});

		if("business_unit_id" in object) {
			const { allWorkOrders } = this.state;
			let workOrdersList = [];
			if(object.business_unit_id) {
				workOrdersList = allWorkOrders.filter(item => item.business_unit_id === object.business_unit_id).map(item => ({
					value: item.id,
					label: (item.old_code) ? item.code + ' - ' + item.old_code : item.code
				}));
			} else {
				workOrdersList = allWorkOrders.map(item => ({
					value: item.id,
					label: (item.old_code) ? item.code + ' - ' + item.old_code : item.code
				}));
			}

			this.setState({workOrdersList: workOrdersList});
		}

		this.loadDashboardSearchFormSubmit(searchForm);
	};

	loadDashboard = async () => {
		const {notifyError} = this.props;
		try {
			const response = await api.get(`/dashboard/5`);

			const businessUnitsList = response.data.business_units.map(item => ({
				value: item.id,
				label: item.code + ' - ' + item.name
			}));

			const allWorkOrders = response.data.work_orders;
			const workOrdersList = response.data.work_orders.map(item => ({
				value: item.id,
				label: (item.old_code) ? item.code + ' - ' + item.old_code : item.code
			}));

			const statusesList = response.data.statuses.map(item => ({
				value: item,
				label: item
			}));

			const userApprovedStatusesList = response.data.user_approved_statuses.map(item => ({
				value: item,
				label: item
			}));

			const jobStatusesList = response.data.job_status.map(item => ({
				value: item,
				label: item
			}));

			this.setState({
				isLoading: false,
				allWorkOrders: allWorkOrders,
				businessUnitsList: businessUnitsList,
				workOrdersList: workOrdersList,
				statusesList: statusesList,
				userApprovedStatusesList: userApprovedStatusesList,
				jobStatusesList :jobStatusesList
			});
		} catch (error) {
			notifyError(error.message);
		}
	};

  loadDashboardSearchFormSubmit = async (values) => {
		const {notifySuccess, notifyError} = this.props;
		if(!values.business_unit_id && !values.work_order_id) {
			this.setState({workInstructions: []});
			return;
		}

		this.setState({isLoading: true});
		try {
			const formData = Object.assign({}, values);

			const response = await api.post('/dashboard/5/search', formData);
			notifySuccess(response.message);

			const workInstructions = response.data.work_instructions;
			this.setState({isLoading: false,  workInstructions: workInstructions});
		} catch (error) {
			this.setState({isLoading: false});
			notifyError(error.message);
		}
	};

	openLightBox = async (e, id) => {
		const {notifyError} = this.props;
		if(!id) {
			return;
		}

		try {
			const response = await api.get(`/dashboard/5/work-instruction/${id}`);
			const { work_instruction: workInstruction } = response.data;

			const imageList = [];
			if (workInstruction.type === 'Steps') {
				for (let i = 0; i < workInstruction.steps.length; i++) {
					for (let j = 0; j < workInstruction.steps[i].sequences.length; j++) {
						imageList.push({
							src: workInstruction.steps[i].sequences[j].image_name_url,
							caption: workInstruction.steps[i].sequences[j].description
						});
					}
				}
			}

			this.setState({
				isLightBoxOpen: true,
				lightBoxImages: imageList,
				lightBoxImageIndex: 0
			});

			const intervalId = setInterval(() => {
				this.gotoNextLightBox();
			}, 10000);
			this.setState({intervalId: intervalId});
		} catch (error) {
			notifyError(error.message);
		}
	};

	closeLightBox = () => {
		this.setState({
			isLightBoxOpen: false
		});

		clearInterval(this.state.intervalId);
	};

	gotoPreviousLightBox = () => {
		const {lightBoxImageIndex, lightBoxImages} = this.state;
		this.setState({
			lightBoxImageIndex: (lightBoxImageIndex + lightBoxImages.length - 1) % lightBoxImages.length
		});
	};

	gotoNextLightBox = () => {
		const {lightBoxImageIndex, lightBoxImages} = this.state;
		this.setState({
			lightBoxImageIndex: (lightBoxImageIndex + 1) % lightBoxImages.length
		});
	};

	render() {
		const {translate, session} = this.props;
		const permissionNames = session.permission_names;
		const {
			businessUnitsList, workOrdersList, statusesList, userApprovedStatusesList, jobStatusesList, searchForm, workInstructions,
			isLightBoxOpen, lightBoxImages, lightBoxImageIndex
		} = this.state;

		const content = (
			<div className="content-wrapper">
				<section className="content">
					<div className="box">
						<div className="box-body with-top-padding">
							<div className="row">
								<div className="col-md-3">
                  <div className="form-group">
                    <Label text={translate('dashboard_page_business_unit_id')}/>
                    <VSelect multi={true} list={businessUnitsList} clearable={true} value={searchForm.business_unit_id} onChange={selected => this.updateSearchFormState({business_unit_id: selected || ''})}/>
                  </div>
								</div>
								<div className="col-md-3">
									<div children="form-group">
										<Label text={translate('dashboard_page_work_order_id')}/>
										<VSelect list={workOrdersList} clearable={true} value={searchForm.work_order_id} onChange={selected => this.updateSearchFormState({work_order_id: selected || ''})} />
									</div>
								</div>
								<div className="col-md-2">
									<div children="form-group">
										<Label text={translate('dashboard_page_status')}/>
										<VSelect list={statusesList} value={searchForm.status} onChange={selected => this.updateSearchFormState({status: selected})} />
									</div>
								</div>
								<div className="col-md-2">
									<div children="form-group">
										<Label text={translate('dashboard_page_user_approved_status')}/>
										<VSelect list={userApprovedStatusesList} value={searchForm.user_approved_status} onChange={selected => this.updateSearchFormState({user_approved_status: selected})} />
									</div>
								</div>
								<div className="col-md-2">
									<div children="form-group">
										<Label text={translate('dashboard_page_job_status')}/>
										<VSelect list={jobStatusesList} value={searchForm.job_status} onChange={selected => this.updateSearchFormState({job_status: selected})} />
									</div>
								</div>
							</div>
						</div>
					</div>

					{(workInstructions.length > 0) && (
						<Fragment>
							<div className="row">
								{workInstructions.map((workInstruction, index) => {
									return (
										<div className="col-md-4" key={`dashboard_work_instruction_${index}`}>
											<div className="info-box info-box-icon-right custom-info-box">
												{
													<span className={ (workInstruction.video) ? "info-box-icon bg-green" : "info-box-icon bg-grey"} onClick={e => this.openModal(e, workInstruction.video_url)}>
														<i className="fa fa-play-circle"/>
													</span>
												}
												{
													<span className={ (workInstruction.type === "Steps") ? "info-box-icon bg-green" : "info-box-icon bg-grey"} style={{borderRight: '1px solid white'}} onClick={e => this.openLightBox(e, workInstruction.id)}>
														<i className="fa fa-clipboard"/>
													</span>
												}
												<div className="info-box-content">
													<span className="info-box-text">
														{
															permissionNames && permissionNames.includes('view_work_instruction')
																? <IconLink type="link" to={`/work-instructions/detail/${workInstruction.id}`} text={workInstruction.code}/>
																: workInstruction.code
														}
													</span>
													<span className="info-box-number">
														{
															workInstruction.description
														}
													</span>
												</div>

											</div>
										</div>
									)
								})}
							</div>
							<Lightbox
								isOpen={isLightBoxOpen}
								images={lightBoxImages}
								currentImage={lightBoxImageIndex}
								onClickPrev={this.gotoPreviousLightBox}
								onClickNext={this.gotoNextLightBox}
								onClose={this.closeLightBox}
								backdropClosesModal={true}
							/>
						</Fragment>
						)
					}
				</section>

				<Modal show={this.state.modalOpen} onHide={this.closeModal}>
					<Modal.Header closeButton>
						<Modal.Title id='ModalHeader'>Video</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						{
							this.state.modalOpen && (
								<Player src={this.state.modalVideoSrc} autoPlay={false} loop={true}>
									<BigPlayButton position="center" />
									<ControlBar autoHide={false}>
										<ReplayControl seconds={30} order={2.1} />
									</ControlBar>
								</Player>
							)
						}
					</Modal.Body>
				</Modal>
			</div>
		);

		return translate('dashboard_page_title') ? content : <ContentLoader/>;
	}
}

const mapStateToProps = state => ({
	translate: getTranslate(state.locale),
	session: state.session,
});

const mapDispatchToProps = dispatch => bindActionCreators({
	loadLanguage,
	notifyError,
	notifySuccess
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DashboardBox5);
